<template>
	<form class="contact__form form" @submit.prevent="sendMail">
		<div class="contact__label">Napisz do nas</div>
		<div class="form__fields">
			<div class="form__group" :class="{ 'form__group--error': $v.name.$error }">
				<label class="form__label">Imię i nazwisko</label>
				<input class="form__input" v-model.trim="$v.name.$model" placeholder="Imię i nazwisko..." />
				<div class="form__errors" v-if="$v.name.$error">
					<div class="form__error" v-if="!$v.name.required">Pole jest wymagane</div>
					<div class="form__error" v-if="!$v.name.minLength">Pole musi posiadać conajmniej {{$v.name.$params.minLength.min}} znaków</div>
				</div>
			</div>
			<div class="form__group">
				<label class="form__label">Firma</label>
				<input class="form__input" v-model.trim="$v.company.$model" placeholder="Firma..." />
				<div class="form__errors" v-if="$v.company.$error">
					<div class="form__error" v-if="!$v.company.required">Pole jest wymagane</div>
				</div>
			</div>
			<div class="form__group">
				<label class="form__label">E-mail</label>
				<input class="form__input" v-model.trim="$v.mail.$model" placeholder="E-mail..." />
				<div class="form__errors" v-if="$v.mail.$error">
					<div class="form__error" v-if="!$v.mail.required">Pole jest wymagane</div>
					<div class="form__error" v-if="!$v.mail.email">Nieprawidłowy adres e-mail</div>
				</div>
			</div>
			<div class="form__group">
				<label class="form__label">Wiadomość</label>
				<textarea class="form__input form__input--textarea" v-model="message" placeholder="Wiadomość..."></textarea>
			</div>
			<ButtonPrimary class="send-mail">Wyślij</ButtonPrimary>
		</div>
	</form>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/components/contact/contact-form';
@import '@/assets/scss/components/form/form';
</style>


<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import { required, minLength, email } from 'vuelidate/lib/validators'

export default {
	name: 'ContactForm',
	components: {
		'ButtonPrimary': () => import('@/pages/components/buttons/ButtonPrimary'),
	},
	data() {
		return {
			name: '',
			company: '',
			mail: '',
			message: '',
			submitStatus: null,
		}
	},
	methods: {
		sendMail() {
			this.$v.$touch();
			if (!this.$v.$invalid) {
				alert('success');
			}
		}
	},
	validations: {
		name: {
			required,
			minLength: minLength(5)
		},
		company: {
			required,
		},
		mail: {
			required,
			email,
		},
	},
}
</script>